/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiEntitlementThreshold } from './EntitlementThreshold';
import { ApiMembershipProduct } from './MembershipProduct';
import { ApiValueProp } from './ValueProp';
import { ApiOffer } from './Offer';
import { ApiAffiliate } from './Affiliate';

export interface OfferSetRequest {

    /**
     * Offer Set UUID
     */
    uuid?: string;

    /**
     * Numeric ID of the offer set
     */
    id?: number;

    /**
     * Name of the offer set
     */
    name?: string;

    /**
     * Description of the offer set
     */
    description?: string;

    /**
     * Default status of the offer set
     */
    default?: boolean;

    /**
     * Available status of the offer set
     */
    available?: boolean;

    /**
     * Publish status of the offer set
     */
    published?: boolean;

    /**
     * Kind of the Offer Set (embedded, signup)
     */
    kind?: string;

    /**
     * Flag to indicate if this should be grouped
     */
    group?: boolean;

    /**
     * True if the offer set contains suggested price options
     */
    is_pay_what_you_want?: boolean;

    /**
     * Type of offer set, 'classic' or 'modern'
     */
    style?: string;

    /**
     * Minimum amount for monthly PWYW purchase, in cents
     */
    minimum_monthly_price?: number;

    /**
     * Minimum amount for annual PWYW purchase, in cents
     */
    minimum_annual_price?: number;

    /**
     * Minimum amount for a contribution purchase, in cents
     */
    minimum_contribution_amount?: number;

    entitlement_thresholds?: ApiEntitlementThreshold[];

    /**
     * Title for Membership Value Prop area 
     */
    membership_value_prop_title?: string;

    /**
     * Subtitle for Membership Value prop area
     */
    membership_value_prop_subtitle?: string;

    membership_value_props?: string[];

    /**
     * Number of introductory periods for monthly plans. Applies to Pay What You Want offer sets only. If zero, PWYW is permanent. If non-zero, PWYW is introductory.
     */
    pwyw_monthly_introductory_periods?: number;

    /**
     * Number of introductory periods for annual plans. Applies to Pay What You Want offer sets only. If zero, PWYW is permanent. If non-zero, PWYW is introductory.
     */
    pwyw_annual_introductory_periods?: number;

    pwyw_monthly_introductory_product?: ApiMembershipProduct;

    pwyw_annual_introductory_product?: ApiMembershipProduct;

    /**
     * Title shown in the Company Value Props section
     */
    company_value_props_title?: string;

    company_value_props?: ApiValueProp[];

    /**
     * Page title for the Pricing Step, usually 'Become a Member'
     */
    page_title?: string;

    /**
     * Pricing Prompt shown at the top of the pricing area
     */
    pricing_prompt?: string;

    /**
     * Summary for Pricing Prompt
     */
    pricing_prompt_summary?: string;

    /**
     * Banner title for the profile section prompts
     */
    profile_prompt_title?: string;

    /**
     * Subtitle for the profile section prompts
     */
    profile_prompt_subtitle?: string;

    /**
     * Details for the profile section prompts
     */
    profile_prompt_details?: string;

    /**
     * Banner title for the payment section prompts
     */
    payment_prompt_title?: string;

    /**
     * Subtitle for the payment section prompts
     */
    payment_prompt_subtitle?: string;

    /**
     * Details for the payment section prompts
     */
    payment_prompt_details?: string;

    /**
     * Contenful Id for featured media
     */
    featured_media_production_cfid?: string;

    /**
     * Contenful Id for featured media
     */
    featured_media_vod_cfid?: string;

    /**
     * Contenful Id for featured article
     */
    featured_article_cfid?: string;

    /**
     * Additional hyperlink text (to be shown below offer cards)
     */
    link_text?: string;

    /**
     * Additional hyperlink URL (to be shown below offer cards)
     */
    link_url?: string;

    offers?: ApiOffer[];

    /**
     * Affiliate user
     */
    affiliate?: ApiAffiliate;

    mobile_image?: string;

    tablet_image?: string;

    desktop_image?: string;

    /**
     * Headline for Social embed
     */
    embed_headline?: string;

    /**
     * Description for Social embed
     */
    embed_description?: string;

    /**
     * Image url for Social embed
     */
    embed_image_url?: string;

    /**
     * Label for Tier 1
     */
    tier1_label?: string;

    /**
     * Summary for Tier 1
     */
    tier1_summary?: string;

    /**
     * Tooltip for Tier 1
     */
    tier1_tooltip?: string;

    /**
     * Label for Tier 2
     */
    tier2_label?: string;

    /**
     * Summary for Tier 2
     */
    tier2_summary?: string;

    /**
     * Tooltip for Tier 2
     */
    tier2_tooltip?: string;

}

@Model('OfferSet')
export class ApiOfferSet extends BaseModel implements OfferSetRequest {

    /**
     * Offer Set UUID
     */
    
    
    uuid: string;

    /**
     * Numeric ID of the offer set
     */
    
    
    id: number;

    /**
     * Name of the offer set
     */
    
    
    name: string;

    /**
     * Description of the offer set
     */
    
    
    description: string;

    /**
     * Default status of the offer set
     */
    
    
    default: boolean;

    /**
     * Available status of the offer set
     */
    
    
    available: boolean;

    /**
     * Publish status of the offer set
     */
    
    
    published: boolean;

    /**
     * Kind of the Offer Set (embedded, signup)
     */
    
    
    kind: string;

    /**
     * Flag to indicate if this should be grouped
     */
    
    
    group: boolean;

    /**
     * True if the offer set contains suggested price options
     */
    
    
    is_pay_what_you_want: boolean;

    /**
     * Type of offer set, 'classic' or 'modern'
     */
    
    
    style: string;

    /**
     * Minimum amount for monthly PWYW purchase, in cents
     */
    
    
    minimum_monthly_price: number;

    /**
     * Minimum amount for annual PWYW purchase, in cents
     */
    
    
    minimum_annual_price: number;

    /**
     * Minimum amount for a contribution purchase, in cents
     */
    
    
    minimum_contribution_amount: number;

    @Type('ApiEntitlementThreshold')
    @Expand()
    entitlement_thresholds: ApiEntitlementThreshold[];

    /**
     * Title for Membership Value Prop area 
     */
    
    
    membership_value_prop_title: string;

    /**
     * Subtitle for Membership Value prop area
     */
    
    
    membership_value_prop_subtitle: string;

    
    
    membership_value_props: string[];

    /**
     * Number of introductory periods for monthly plans. Applies to Pay What You Want offer sets only. If zero, PWYW is permanent. If non-zero, PWYW is introductory.
     */
    
    
    pwyw_monthly_introductory_periods: number;

    /**
     * Number of introductory periods for annual plans. Applies to Pay What You Want offer sets only. If zero, PWYW is permanent. If non-zero, PWYW is introductory.
     */
    
    
    pwyw_annual_introductory_periods: number;

    @Type('ApiMembershipProduct')
    @Expand()
    pwyw_monthly_introductory_product: ApiMembershipProduct;

    @Type('ApiMembershipProduct')
    @Expand()
    pwyw_annual_introductory_product: ApiMembershipProduct;

    /**
     * Title shown in the Company Value Props section
     */
    
    
    company_value_props_title: string;

    @Type('ApiValueProp')
    @Expand()
    company_value_props: ApiValueProp[];

    /**
     * Page title for the Pricing Step, usually 'Become a Member'
     */
    
    
    page_title: string;

    /**
     * Pricing Prompt shown at the top of the pricing area
     */
    
    
    pricing_prompt: string;

    /**
     * Summary for Pricing Prompt
     */
    
    
    pricing_prompt_summary: string;

    /**
     * Banner title for the profile section prompts
     */
    
    
    profile_prompt_title: string;

    /**
     * Subtitle for the profile section prompts
     */
    
    
    profile_prompt_subtitle: string;

    /**
     * Details for the profile section prompts
     */
    
    
    profile_prompt_details: string;

    /**
     * Banner title for the payment section prompts
     */
    
    
    payment_prompt_title: string;

    /**
     * Subtitle for the payment section prompts
     */
    
    
    payment_prompt_subtitle: string;

    /**
     * Details for the payment section prompts
     */
    
    
    payment_prompt_details: string;

    /**
     * Contenful Id for featured media
     */
    
    
    featured_media_production_cfid: string;

    /**
     * Contenful Id for featured media
     */
    
    
    featured_media_vod_cfid: string;

    /**
     * Contenful Id for featured article
     */
    
    
    featured_article_cfid: string;

    /**
     * Additional hyperlink text (to be shown below offer cards)
     */
    
    
    link_text: string;

    /**
     * Additional hyperlink URL (to be shown below offer cards)
     */
    
    
    link_url: string;

    @Type('ApiOffer')
    @Expand()
    offers: ApiOffer[];

    /**
     * Affiliate user
     */
    @Type('ApiAffiliate')
    @Expand()
    affiliate: ApiAffiliate;

    
    
    mobile_image: string;

    
    
    tablet_image: string;

    
    
    desktop_image: string;

    /**
     * Headline for Social embed
     */
    
    
    embed_headline: string;

    /**
     * Description for Social embed
     */
    
    
    embed_description: string;

    /**
     * Image url for Social embed
     */
    
    
    embed_image_url: string;

    /**
     * Label for Tier 1
     */
    
    
    tier1_label: string;

    /**
     * Summary for Tier 1
     */
    
    
    tier1_summary: string;

    /**
     * Tooltip for Tier 1
     */
    
    
    tier1_tooltip: string;

    /**
     * Label for Tier 2
     */
    
    
    tier2_label: string;

    /**
     * Summary for Tier 2
     */
    
    
    tier2_summary: string;

    /**
     * Tooltip for Tier 2
     */
    
    
    tier2_tooltip: string;

}
